// extracted by mini-css-extract-plugin
module.exports = {"SaveElectricB":"B_SaveElectricB__omKyp"};